__turbopack_context__.v({
  "root": "CartItems-module__NU27ba__root",
});
